import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_remote_printing_handlerService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { printer_name: string, report_name: string, report_inputs: any, debug_mode?: boolean }): Promise<{ debug?: any }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.printer_name)) {
      $missingRequiredInParams.push('\'printer_name\'');
    }
    if (isNil($inParams.report_name)) {
      $missingRequiredInParams.push('\'report_name\'');
    }
    if (isNil($inParams.report_inputs)) {
      $missingRequiredInParams.push('\'report_inputs\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/remote_printing_handler`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

